exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".hextech-wrapper-3knnA{position:relative}.hextech-bar-q-qTP{height:2px;margin-top:-2px;transition:transform 0.4s ease, width 0.2s ease;background:#785a28;will-change:transform, width;transform:translateX(0px);width:0px}.hextech-list-36sPc{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;list-style:none;margin:0;padding:0}.hextech-item-36eeC{position:relative;list-style:none;text-transform:capitalize;padding:20px 14px;color:#cdbe91;transition:color 0.4s ease;letter-spacing:0.2px}.hextech-item-36eeC:hover,.hextech-item-36eeC.hextech-active-HIiiN{color:#f0e6d2}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "hextech-wrapper-3knnA",
	"bar": "hextech-bar-q-qTP",
	"list": "hextech-list-36sPc",
	"item": "hextech-item-36eeC",
	"active": "hextech-active-HIiiN"
};